import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';
import { Auth } from '../services/auth';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): ReturnType<HttpHandlerFn> => {
  const authService = inject(Auth);
  const router = inject(Router);

  const skipAuthUrls = [
    '/auth/config',
    '/auth/google'
  ];
  const shouldSkipAuth = skipAuthUrls.some(url => req.url.includes(url));

  const token = authService.getAccessToken();
  const authReq = token && !shouldSkipAuth
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
    : req;

  return next(authReq).pipe(
    tap(event=> {
      if(event instanceof HttpResponse){
        const updatedAccessToken = event.headers.get('Authorization') || null;
        if(updatedAccessToken && updatedAccessToken !== token) {
          authService.setAccessToken(updatedAccessToken);
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      console.log('HTTP Error:', JSON.stringify(error));
      if (error.status === 401) {
        console.log('Unauthorized response detected. Initiating logout process.' + authService.getLogoutProcess());
        if (!authService.getLogoutProcess()) {
          authService.logout('session-expired');
        }
      } else if (error.status === 403) {
        console.log('Forbidden response detected.');
        router.navigate(['/no-assignment']);
      }
      return throwError(() => error);
    })
  );
};
